import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import img from "./assets/images/Flight_Booking_Logo.png";

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4">
      <div className="container">
        <div className="row text-start">
          {" "}
          {/* Apply text-start to align everything left */}
          {/* Logo and Copyright Section */}
          <div className="col-md-4">
            <Link className="navbar-brand" to="/">
              <img
                src={img}
                alt="FlightBook Logo"
                className="d-inline-block align-top"
                style={{ height: "60px" }}
              />
            </Link>
            <p className="mb-1">
              We believe that booking a flight should be easy,{" "}
            </p>
            <p className="mb-1">convenient, and budget-friendly, which is</p>
            <p className="mb-1">why we offer 24/7 customer support and </p>
            <p>expert assistance at every step of your journey.</p>
          </div>
          {/* Company Section */}
          <div className="col-md-4">
            <h5 className="fw-bold">Important Link</h5>
            <ul className="list-unstyled">
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/privacy">
                  Privacy policy
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/terms">
                  Terms And Condition
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/refund">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
          {/* Social Media Section */}
          <div className="col-md-4">
            <h5 className="fw-bold">Our Office</h5>
            <ul>
              <li>Address: My flight Bookings LLC   30 N Gould St STE R Sheridan WY 82801</li>
                <li>Email: info@flightbooking.com</li>
                <li>Phone: 1-877-254-8655</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div
        class="text-center p-2"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
      >
        <a
          class="text-reset fw-bold"
          href="https://www.kumarinfotech.net/"
          style={{ textDecoration: "none" }}
        >
          {" "}
          Developed by Kumarinfotech
        </a>
      </div> */}
      <div>
      <span>
      <p style={{ color: "white" }}>
        Copyright <i className="bx bx-copyright"></i> {new Date().getFullYear()}. Designed &amp; Developed By
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.kumarinfotech.net/"
          style={{ color: "white", marginLeft: "5px" }}
        >
          Kumarinfotech
        </a>
      </p>
    </span>
      </div>
    </footer>
  );
};

export default Footer;
